const NUMBER_PATTERN = /\d[\d.,]*\d|\d/g;
const THOUSANDS_GROUP = /\B(?=(\d{3})+(?!\d))/g;

function _findDecimalSeparator(digits) {
  const lastSeparatorIndex = Math.max(digits.lastIndexOf('.'), digits.lastIndexOf(','));

  if (lastSeparatorIndex < 0) return null;

  const separator = digits[lastSeparatorIndex];
  const isRepeated = digits.indexOf(separator) !== lastSeparatorIndex;
  const decimals = digits.length - lastSeparatorIndex - 1;

  return isRepeated || decimals === 3 ? null : separator;
}

/**
 * Lê um valor já formatado ("R$ 1.234,56", "US$ 1,234.56", "12%") sem depender de idioma.
 * Texto sem número, ou com mais de um número, volta null: ele aparece direto, sem animar.
 */
export function parseFormattedNumber(text) {
  const matches = String(text ?? '').match(NUMBER_PATTERN);

  if (matches?.length !== 1) return null;

  const [digits] = matches;
  const decimalSeparator = _findDecimalSeparator(digits);
  const [integerPart, decimalPart = ''] = decimalSeparator ? digits.split(decimalSeparator) : [digits];
  const thousandsSeparator = integerPart.match(/[.,]/)?.[0] ?? null;
  const start = String(text).indexOf(digits);

  return {
    prefix: String(text).slice(0, start),
    suffix: String(text).slice(start + digits.length),
    number: Number(`${integerPart.replace(/[.,]/g, '')}.${decimalPart || 0}`),
    decimals: decimalPart.length,
    decimalSeparator,
    thousandsSeparator
  };
}

/** Escreve `number` no mesmo formato de `parsed`. */
export function formatLike(parsed, number) {
  const [integerPart, decimalPart] = number.toFixed(parsed.decimals).split('.');
  const grouped = parsed.thousandsSeparator ? integerPart.replace(THOUSANDS_GROUP, parsed.thousandsSeparator) : integerPart;
  const body = decimalPart ? `${grouped}${parsed.decimalSeparator}${decimalPart}` : grouped;

  return `${parsed.prefix}${body}${parsed.suffix}`;
}
